export const environment = {
  name: 'prod',
  production: true,
  appBaseHref: '/',
  genesysCloud: {
    clientId: 'c2076938-baf4-4991-8c99-def20227b658', // Use the same client Id used for know-client orchestrators l2c
  },
  api: {
    kepler: {
      slapfive: {
        apiKey: 'DrQIOwR1b86azyUrQ71Bj9SwAqwdCDJQ9Pm0qLHO',
        url: 'https://kepler-slapfive-api.genesyscsdt.com/prod',
      },
    },
  },
  orchestrator: {
    baseUrl: 'https://orchestrators.genesys.com',
  },
  featureFlags: {
    limitedRegionView: false,
  },
};
